<template>
  <nuttrema-layout-content>
    <template slot="header">
      <persons-standard-header
        :edit.sync="edit"
        :meta="meta"
        :PersonDetails="PersonDetails">
      </persons-standard-header>
    </template>

    <template slot="central">
      <nuttrema-loader v-if="PersonDetails.fetching"></nuttrema-loader>
      <form-person-profile-picture
         v-else
        :edit.sync="edit"
        :PersonDetails="PersonDetails"
        @uploadProfilePicture="uploadProfilePicture"
        @removeProfilePicture="removeProfilePicture"
        @uploadProfilePictureSuccess="handleUploadProfilePictureSuccess">
      </form-person-profile-picture>
    </template>
  </nuttrema-layout-content>
</template>

<script>
import { mapActions } from 'vuex';

import PageProps from 'components/mixins/page-props';

import NuttremaLayoutContent from 'components/ui/layout/nuttrema-layout-content';
import PersonsStandardHeader from 'components/pages/professional/persons/participants/shared/blocks/cmpt-persons-standard-header';

import FormPersonProfilePicture from './form-person-profile-picture';

export default {
  name: 'page-person-profile-picture',
  mixins: [
    PageProps,
  ],
  props: {
    id: {
      required: true,
      default: null,
    },
    type: {
      required: true,
      default: null,
    },
  },
  components: {
    NuttremaLayoutContent,
    PersonsStandardHeader,
    FormPersonProfilePicture,
  },
  data() {
    return {
      edit: false,
    };
  },
  computed: {
    PersonDetails() {
      return this.$store.getters.PersonDetails(this.id);
    },
  },
  methods: {
    ...mapActions([
      'SavePersonProfilePicture',
      'RemovePersonProfilePicture',
    ]),
    uploadProfilePicture(file) {
      this.SavePersonProfilePicture({
        id: this.id,
        type: this.type,
        file,
      }).then(() => {
        this.successNotification({ label: 'label.profile_picture' });
      }).catch(() => {
        this.errorNotification({ label: 'label.profile_picture' });
      });
    },
    removeProfilePicture() {
      this.RemovePersonProfilePicture({
        id: this.id,
        type: this.type,
      }).then(() => {
        this.successNotification({ message: 'message.default_success_delete_message', label: 'label.profile_picture' });
      }).catch(() => {
        this.errorNotification({ message: 'message.default_error_delete_message' });
      });
    },
    handleUploadProfilePictureSuccess() {},
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/shared/profile-picture/page-person-profile-picture.vue